import { AppReviewDemoStatusResponse } from "../contracts/AppReviewDemoStatusResponse";
import { AppReviewDemoStatus } from "../models/AppReviewDemoStatus";

export const mapResponseToAppReviewDemoStatus = (
  response: AppReviewDemoStatusResponse
): AppReviewDemoStatus => ({
  accountsConfigured: response.accountsConfigured,
  prepared: response.prepared,
  organizationId: response.organizationId ?? null,
  ownerInstructorId: response.ownerInstructorId ?? null,
  preparedAt: response.preparedAt ? new Date(response.preparedAt) : null,
  languageCode: response.languageCode ?? null,
  memberCount: response.memberCount ?? 0,
  sessionCount: response.sessionCount ?? 0,
  contractCount: response.contractCount ?? 0,
  paymentCount: response.paymentCount ?? 0,
  issues: response.issues ?? [],
});
